const BaseModule = require('../../90_utils/base/BaseModule');

class HeroController extends BaseModule {

	constructor(el, params) {

		super(el);

		this.data = params.data;

		// element vars

		this.pageId;
		this.sectionId;

		this.$currentHero = this.$el.find('.hero');
		this.$footerHero;

		this.isFirstPage = true;
	}

	// basemodule methods

	_domReady(){ }

	_addListeners(){ }
	_removeListeners(){ }

	// content changing

	transOutContent(pageId, sectionId, isScrollSwap){

		return new Promise((resolve, reject) => {

			if(this.$currentHero && this.$currentHero.length){

				this.$currentHero.triggerHandler('disable');
				this.$currentHero.find('[data-js-module]').each((index, value) => {
					$(value).triggerHandler('disable');
				});

				TweenMax.killTweensOf(this.$currentHero);

				console.log('transOutContent', pageId, sectionId, isScrollSwap, this.$footerHero);

				if(isScrollSwap && this.$footerHero && this.$footerHero.length){
					this.$footerHero.find('.inner-wrapper').addClass('is-fixed');
				}

				resolve();
			}
		});
	}

	transInContent(pageId, sectionId, isScrollSwap){

		return new Promise((resolve, reject) => {

			if(this.$currentHero && this.$currentHero.length){

				this.$currentHero.find('.inner-wrapper').removeClass('is-fixed');
				this.$currentHero.triggerHandler('show');

				TweenMax.killTweensOf(this.$currentHero);
				resolve();
			}
		});
	}

	swapContentById(pageId, sectionId, isScrollSwap){

		// console.log('hero swapContentById', pageId, sectionId);

		return new Promise((resolve, reject) => {

			let addFooter = (id) => {

				let footerObj = this.getNextFooterById(id);

				console.log(`addFooter '${id}' '${footerObj}'`);

				if(footerObj){

					if(this.$footerHero && this.$footerHero.length){
						this.$footerHero.triggerHandler('disable');
						this.$footerHero.remove();
						this.$footerHero = null;
					}

					this.$footerHero = $(footerObj.template);
					this.$footerHero.addClass('footer-hero');
					this.$el.append(this.$footerHero);

					window.vent.trigger('domUpdate');
				}
			}

			if(pageId !== this.pageId || sectionId !== this.sectionId || this.isFirstPage){

				let $oldHero;
				let $oldFooter;
				let resolveDelay = window.SETTINGS.breakpoint.minWidth('screen-medium') ? 200 : 200;

				if(this.isFirstPage){

					console.log("first page");

					this.isFirstPage = false;
					this.pageId = pageId;
					this.sectionId = sectionId;

					this.$currentHero = this.$el.find('.hero');
					resolve();
				}
				else {

					console.log("not first page");

					this.pageId = pageId;
					this.sectionId = sectionId;

					if(isScrollSwap){

						$oldHero = this.$currentHero;
						$oldHero.addClass('old');
						$oldHero.triggerHandler('disable');

						this.$currentHero = this.$footerHero;
						this.$footerHero = null;

						this.$currentHero.removeClass('footer-hero');

						this.$currentHero.triggerHandler('updateStatus'); // you're no longer a footer, son.
						this.$currentHero.triggerHandler('completeIntro'); // second half of intro

						console.log('complete footer', this.$currentHero);
					}
					else {

						$oldHero = this.$currentHero;
						$oldHero.addClass('old');
						$oldHero.triggerHandler('disable');

						if(this.$footerHero && this.$footerHero.length){
							$oldFooter = this.$footerHero;
							$oldFooter.addClass('old');
							$oldFooter.triggerHandler('disable');
						}

						this.$currentHero = $(this.getHeroById(this.sectionId || this.pageId).template);
						this.$footerHero = null;

						// console.log('!!! get hero', this.getHeroById(this.sectionId || this.pageId));

						this.$el.append(this.$currentHero);

						if(window.SETTINGS.breakpoint.minWidth('screen-medium')){

							this.$currentHero.css('opacity', 0);

							if($(window).scrollTop() > $oldHero.outerHeight()){
								$oldHero.css('opacity', 0);
							}

							window.setTimeout(() => {
								window.vent.trigger('domUpdate');
							}, 0);

							TweenMax.fromTo(this.$currentHero, 0.4, {opacity:0}, {opacity:1, ease:'longFade'});
							resolveDelay = 400;
						}
					}
				}

				window.setTimeout(() => {

					// console.log("hero resolve");

					if($oldHero && $oldHero.length){
						$oldHero.remove();
					}

					if($oldFooter && $oldFooter.length){
						$oldFooter.remove();
					}

					addFooter(this.sectionId || this.pageId);
					resolve();

				}, resolveDelay);
			}
			else {
				resolve();
			}
		});
	}

	swapContentByIndex(index){
		this.swapContentById(window.SETTINGS.templates.heroes[index].id);
	}

	//

	getHeroById(id){

		let recursiveSearch = (container, id) => {
			// console.log('getHeroById', id, container);
			for(let i=0; i<container.length; i++){
				let child = container[i];
				if(child.id === id){
					return child;
				}
				if(child.sections){
					let returnObj = recursiveSearch(child.sections, id);
					if(returnObj){ return returnObj; }
				}
			}
		}

		let result = recursiveSearch(window.SETTINGS.templates.heroes, id);
		return (result === true) ? null : result;
	}

	getNextFooterById(id){

		let checkForChildren = (footerContainer) => {
			if(footerContainer.sections){
				return footerContainer.sections[0];
			}
			return footerContainer;
		}

		let recursiveSearch = (container, id) => {

			for(let i=0; i<container.length; i++){

				let child = container[i];

				if(child.id === id){
					if(child.sections){
						return child.sections[1];
					}
					else if(i + 1 < container.length){
						return checkForChildren(container[i + 1]);
					}
					else {
						return true;
					}
				}

				if(child.sections){

					let nextFooter = recursiveSearch(child.sections, id);

					if(nextFooter === true){
						if(i + 1 < container.length){
							return checkForChildren(container[i + 1]);
						}
						else {
							return true;
						}
					}
					else if(nextFooter){
						return checkForChildren(nextFooter);
					}
				}
			}

			return '';
		}

		let result = recursiveSearch(window.SETTINGS.templates.heroes, id);
		return (result === true) ? null : result;
	}

	// show / hide

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }
}

module.exports = HeroController;
